import { sagas as alertSaga } from './alertDiagnostics';
import { sagas as nocDrilldownSaga } from './nocDrilldown';
import { sagas as aiAlertSaga } from './aiAlertDiagnostics';


export default [
  ...alertSaga,
  ...nocDrilldownSaga,
  ...aiAlertSaga,
];
